import OurTeam from './OurTeam';

export default OurTeam;